// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-header-component {
  background-color: var(--sub-1);
  box-shadow: 0 0 23px 0 rgba(153, 153, 153, 0.2);
  z-index: 1;
  position: relative;
}

.page-sub-header-component {
  border-bottom: 0.1px solid var(--sub-5);
}
.page-sub-header-component .page-sub-header-component__description {
  color: var(--sub-5);
}

.step-component {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.step-component .step-component__step {
  padding: 10px;
  text-align: center;
  width: 100%;
  background-color: white;
  border: 1px solid var(--sub-4);
}
.step-component .step-component__step.step--current {
  background-color: var(--main-1);
  color: var(--sub-1);
}
.step-component .step-component__step:first-child {
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
}
.step-component .step-component__step:last-child {
  border-bottom-right-radius: 30px;
  border-top-right-radius: 30px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
